const getAccountField = (account, snakeKey, camelKey) =>
  String(account?.[snakeKey] || account?.[camelKey] || '').trim();

export function isBankTransferAvailable(settings) {
  if (!settings?.bank_transfer_enabled) {
    return false;
  }

  const accounts = settings.bank_accounts || [];
  return accounts.some(
    (account) =>
      getAccountField(account, 'bank_name', 'bankName') &&
      getAccountField(account, 'account_name', 'accountName') &&
      getAccountField(account, 'account_number', 'accountNumber')
  );
}

export function getEnabledBankAccounts(settings) {
  if (!settings?.bank_transfer_enabled) {
    return [];
  }

  return [...(settings.bank_accounts || [])]
    .filter(
      (account) =>
        getAccountField(account, 'bank_name', 'bankName') &&
        getAccountField(account, 'account_name', 'accountName') &&
        getAccountField(account, 'account_number', 'accountNumber')
    )
    .sort((left, right) => (left.display_order || 0) - (right.display_order || 0));
}
